import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { types as api } from '@mesa-labs/mesa-api';

export type FaqsState = {
  scope: api.FaqScope;
};

export const initialState: FaqsState = {
  scope: { partnerId: api.Partners.NO_PARTNER, programCode: api.ProgramCodes.NET15 },
};

const faqsSlice = createSlice({
  name: 'faqs',
  initialState,
  reducers: {
    updateScope(state: FaqsState, action: PayloadAction<api.FaqScope>) {
      state.scope = action.payload;
    },
  },
});

export const { updateScope } = faqsSlice.actions;

export default faqsSlice.reducer;
